import { Flex, Stack, type StackProps, StackSeparator } from '@chakra-ui/react';
import { Link } from 'react-router';
import Logo from '@components/Logo';
import ToggleColorMode from '@components/ToggleColorMode';

import SidebarLink from './SidebarLink';
import UserProfile from './UserProfile';
import Logout from './Logout';
import useMenuList from '../useMenuList'
import { SIDEBAR_WIDTH } from '../utils/sizes';

type Props = StackProps & {
  onClose?: () => void;
};

const Sidebar = (props: Props) => {
  const menuList = useMenuList();

  return (
    <Stack
      maxW={{ base: 'xs', md: SIDEBAR_WIDTH }}
      height="100vh"
      position={{ base: 'auto', md: 'fixed' }}
      flex="1"
      p={{ base: '4', md: '6' }}
      justifyContent="space-between"
      bg="grayscale"
      overflow="hidden"
      {...props}
    >
      <Stack gap="6">
        <Link to="/painel">
          <Logo width={100} />
        </Link>
        <Stack gap="1" colorPalette="argos">
          {menuList.map((item) => (
            <SidebarLink key={item.label} path={item.path} onClose={props.onClose}>
              {item.icon} {item.label}
            </SidebarLink>
          ))}
        </Stack>
      </Stack>
      <Stack gap="4" separator={<StackSeparator />}>
        <UserProfile />
        <Flex justifyContent="space-between" alignItems="center">
          <Logout />
          <ToggleColorMode />
        </Flex>
      </Stack>
    </Stack>
  );
};

export default Sidebar;
